const GatekeeperSection = () => (
  <section className="gatekeeper-section">
    <div className="container">
      <span className="section-label">04 — QUALIFICATIONS</span>
      <h2 className="section-main-title" style={{ color: 'hsl(0 0% 96%)' }}>
        SYSTEM<br />COMPATIBILITY.
      </h2>

      <div className="sequential-filter">
        {/* Filter Block 1: Client Fit */}
        <div className="filter-block">
          <div className="filter-header">
            <h3>[ RUNNING DIAGNOSTIC: CLIENT FIT ]</h3>
          </div>
          <ul className="filter-list">
            <li className="filter-item">
              <span className="terminal-prompt">&gt;_</span>
              <p><strong>The Reputation Gap:</strong> Your real-world operational authority and respectability are not reflected in your current digital infrastructure.</p>
            </li>
            <li className="filter-item">
              <span className="terminal-prompt">&gt;_</span>
              <p><strong>The Liability:</strong> Your website actively causes friction for your business, functioning as a liability rather than a deployed asset.</p>
            </li>
            <li className="filter-item">
              <span className="terminal-prompt">&gt;_</span>
              <p><strong>The Control Requirement:</strong> You need full ownership of the final product, but you do not want the burden of managing it day-to-day.</p>
            </li>
          </ul>
        </div>

        {/* Filter Block 2: Fatal Errors */}
        <div className="filter-block filter-block-rejected">
          <div className="filter-header filter-header-alert">
            <h3>[ FATAL ERRORS : REJECTED ]</h3>
          </div>
          <ul className="filter-list">
            <li className="filter-item">
              <span className="terminal-prompt">&gt;_</span>
              <p><strong>The Commodity Mindset:</strong> You just need someone to code what you sketched, with no strategic pushback.</p>
            </li>
            <li className="filter-item">
              <span className="terminal-prompt">&gt;_</span>
              <p><strong>The Vanity Metric:</strong> You measure success by cheap traffic, not by qualified business outcomes.</p>
            </li>
            <li className="filter-item">
              <span className="terminal-prompt">&gt;_</span>
              <p><strong>The Digital Brochure:</strong> You view your website as a static poster, not as operational business infrastructure.</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default GatekeeperSection;
